import React from 'react';

import { useAppContext } from 'hooks/useContext';
import { Table, TableHead, TableBody, TableHeader, TableData } from './styles';

export default function Score() {
  const { isDarkMode } = useAppContext();

  // TODO use real data when run code is implemented
  const tmpLevelResult = [
    { name: 'Level 1', score: '10/10', time: '0.01 ms' },
    { name: 'Level 2', score: '7/10', time: '1.23 ms' },
  ];

  return (
    <Table>
      <TableHead isDarkMode={isDarkMode}>
        <tr>
          <TableHeader>Level Name</TableHeader>
          <TableHeader>Score</TableHeader>
          <TableHeader>Time</TableHeader>
        </tr>
      </TableHead>
      <TableBody isDarkMode={isDarkMode}>
        {tmpLevelResult.map((levelResult, index) => (
          <tr key={index}>
            <TableData>{levelResult.name}</TableData>
            <TableData>{levelResult.score}</TableData>
            <TableData>{levelResult.time}</TableData>
          </tr>
        ))}
      </TableBody>
    </Table>
  );
}
